import { useQuery } from "@tanstack/react-query";
import fetchToBackend from "@/utils/fetchToBackend";
import { viewQuotaKeys } from "@/lib/query-keys";
import type { ViewQuota } from "@/types/domain";

/**
 * Cuota mensual de vistas (desbloqueos) de la organización del usuario.
 * Se usa para mostrar el saldo en la barra superior y para los CTAs de desbloqueo.
 */
export function useViewQuota(enabled = true) {
  return useQuery({
    queryKey: viewQuotaKeys.all,
    enabled,
    queryFn: () => fetchToBackend<ViewQuota>("/contractings/views/quota"),
  });
}
